import { ACTION_TYPES } from "./constants";

export const socketSendAction = (type, data) => ({
  type: ACTION_TYPES.SOCKET_SEND,
  payload: { type, data }
});

export const registerComponentLevelSocketListener = (eventName, listener) => (dispatch) => {
  const listenerId = `${eventName}-${Math.ceil(Math.random()*1000000000)}`;

  dispatch({
    type: ACTION_TYPES.REGISTER_COMPONENT_LEVEL_SOCKET_LISTENER,
    payload: {
      eventName,
      listener,
      listenerId
    }
  });

  return listenerId;
};

export const unregisterComponentLevelSocketListener = (eventName, listenerId) => ({
  type: ACTION_TYPES.UNREGISTER_COMPONENT_LEVEL_SOCKET_LISTENER,
  payload: {
    eventName,
    listenerId
  }
});

export const setSocketConnectedAction = () => ({
  type: ACTION_TYPES.SOCKET_CONNECTED
});

export const setSocketDisconnectedAction = () => ({
  type: ACTION_TYPES.SOCKET_DISCONNECTED
});
